import { render, staticRenderFns } from "./projectLimit.vue?vue&type=template&id=2c285d5f&scoped=true"
import script from "./projectLimit.vue?vue&type=script&lang=js"
export * from "./projectLimit.vue?vue&type=script&lang=js"
import style0 from "./projectLimit.vue?vue&type=style&index=0&id=2c285d5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c285d5f",
  null
  
)

export default component.exports